module.exports = __webpack_public_path__ + "static/media/Lurantis_gaussian2.ac8819ce.png";